import React, { useContext, useEffect, useReducer } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import styles from "./JoinModal.module.scss";
import styles_login from "../../../../components/Login/Login.module.scss";
import closebtnImg from "../../../../assets/images/close.png";
import thankYouImg from "../../../../assets/images/landingPage/thankYou.png";
import LoaderImg from "../../../../assets/images/Loader.gif";
import { FirebaseErrorCodes } from "../../../../AppConstants/FirebaseErrorCodes";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { useLocation } from "react-router-dom";
import { authContext } from "../../../../contexts/AuthContext/AuthContextProvider";
import {
  whiteListCountries,
  CITY_DEBOUNCE,
  CITY_FETCH_MIN_CHAR,
  openRoutes,
} from "../../../../AppConstants/Constants";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import { SPECIALITY_DATA } from "../../../../AppData/Speciality";
import {
  Profession_DATA,
  hideSpecialityForProfession,
  showEmployeeCodeForProfession,
} from "../../../../AppData/Profession";

import {
  handleCaretPosition,
  scrollToBottom,
  validateEmail,
  validateName,
} from "../../../../utils/common.utils";
import * as Yup from "yup";
import { SIGN_UP_EVENT } from "../../../../Clevertap/EventNames.ts";
import { getSignUpData } from "../../../../Clevertap/EventHandler.ts";
import { usersAPI } from "../../../../apis/usersAPI.js";
import CustomDropDown from "../../../../components/CustomDropDown/index.js";

const schema = Yup.object({
  firstName: Yup.string()
    .required("First Name is required")
    .min(2, "First Name should have a minimum length of 2")
    .max(50, "First Name should have a maximum length of 50")
    .matches(/^[a-zA-Z ]+$/, "First Name should contain only alphabets")
    .label("First Name"),

  lastName: Yup.string()
    .required("Last Name is required")
    .min(2, "Last Name should have a minimum length of 2")
    .max(50, "Last Name should have a maximum length of 50")
    .matches(/^[a-zA-Z ]+$/, "Last Name should contain only alphabets")
    .label("Last Name"),

  email: Yup.string()
    .email("Enter a valid Email")
    .test("validateEmail", "Please enter a valid Email", (value) =>
      validateEmail(value)
    )
    .required("Email is required")
    .label("Email"),

  phoneNumber: Yup.string()
    .matches(/^[+]?[0-9]+$/, "Mobile Number should be a valid number")
    .test(
      "is-valid-phone-number",
      "Please Enter a valid Mobile Number",
      function (value) {
        return isValidPhoneNumber(value); // Assuming isValidNumber returns true or false
      }
    )
    .label("Mobile Number")
    .required("Mobile Number is required"),

  city: Yup.object()
    .shape({
      state: Yup.string().nullable().notRequired(),
      city: Yup.string().required("City is required"),
      country: Yup.string().nullable().notRequired(),
      pincode: Yup.number().nullable().notRequired(),
      location: Yup.object()
        .shape({
          lat: Yup.number().nullable().notRequired(),
          lng: Yup.number().nullable().notRequired(),
        })
        .nullable()
        .notRequired(),
    })
    .required("City details are required"),

  profession: Yup.string()
    .oneOf(Profession_DATA, "Please select your  Profession")
    .required("Please select your Profession")
    .label("Profession"),

  employeeCode: Yup.string()
    .when("profession", {
      is: (profession) =>
        showEmployeeCodeForProfession.includes(profession?.trim()),
      then: (schema) =>
        schema
          .required("Please Enter your Employee Code")
          .matches(/^\d{8}$/, "Please Enter a valid Employee Code "),
      otherwise: (schema) => schema.nullable().notRequired(),
    })
    .label("Employee Code"),

  speciality: Yup.string()
    .when("profession", {
      is: (profession) =>
        !hideSpecialityForProfession.includes(profession?.trim()),
      then: (schema) =>
        schema
          .required("Please select your Speciality")
          .oneOf(SPECIALITY_DATA, "Please select your Speciality"),
      otherwise: (schema) => schema.nullable().notRequired(),
    })
    .label("Speciality"),
});

const inputs = [
  {
    label: "Name *",
    name: "firstName",
    className: "form-control",
    type: "text",
    placeholder: "First Name",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Name *",
    name: "lastName",
    className: "form-control",
    type: "text",
    placeholder: "Last Name",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Email *",
    name: "email",
    className: "form-control",
    type: "email",
    placeholder: "Enter Your Email Id",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Mobile Number *",
    name: "phoneNumber",
    className: "form-control",
    type: "text",
    placeholder: "Enter Mobile Number",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "City * (Please select from dropdown)",
    name: "city",
    className: "form-control",
    type: "text",
    placeholder: "Please Enter Your City Name",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Profession *",
    name: "profession",
    className: "form-control",
    type: "select",
    placeholder: "Select Your Profession",
    data: Profession_DATA,
    required: false,
    disabled: false,
    readOnly: false,
    needSearch: false,
  },
  {
    label: "Employee Code *",
    name: "employeeCode",
    className: "form-control",
    type: "text",
    placeholder: "Enter Your Employee Code",
    required: false,
    disabled: false,
    readOnly: false,
  },
  {
    label: "Speciality *",
    name: "speciality",
    className: "form-control",
    type: "select",
    placeholder: "Select Your Speciality",
    data: SPECIALITY_DATA,
    required: false,
    disabled: false,
    readOnly: false,
    needSearch: true,
  },
];
const defaultErr = {
  firstName: "",
  lastName: "",
  email: "",
  city: "",
  phoneNumber: "",
  profession: "",
  speciality: "",
  employeeCode: "",
  defaultError: "",
};

const initialState = {
  isLoading: false,
  city: "",
  isRegistered: false,
  utm_source: "",
  utm_medium: "",
  utm_campaign: "",
  errors: {
    ...defaultErr,
  },
};

const Action_Type = {
  handleInputChange: "handleInputChange",
  handleError: "handleError",
  loading: "loading",
  handleUTM: "handleUTM",
};

const reducer = (state, action) => {
  let { type, payload } = action;

  switch (type) {
    case Action_Type.handleInputChange:
      return { ...state, [payload.name]: payload.value };
    case Action_Type.handleError:
    case Action_Type.loading:
    case Action_Type.handleUTM:
    case Action_Type.updateCity:
      return { ...state, ...payload };

    default:
      return { ...state };
  }
};

const JoinModal = () => {
  const { addGAWithNoUser, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const {
    toggleSignInbtn,
    handleFormDetails,
    handlePhoneNumber,
    handleLoginBtn,
    updateMultipleState,
    state: analyticsState,
    resetState,
  } = useContext(authContext);
  const { error, formDetails, loading, alreadyRegistered, isPreFilledData } =
    analyticsState;
  const { phoneNumber, city } = formDetails;
  const [state, dispatch] = useReducer(reducer, initialState);
  const { pathname, search = "", hash = "" } = useLocation();

  useEffect(() => {
    let decodedSearch = decodeURIComponent(search);
    let returnURL = new URLSearchParams(decodedSearch).get("returnURL");
    let obj = {
      utm_source: new URLSearchParams(decodedSearch).get("utm_source"),
      utm_medium: new URLSearchParams(decodedSearch).get("utm_medium"),
      utm_campaign: new URLSearchParams(decodedSearch).get("utm_campaign"),
    };
    if (returnURL) {
      let utm_source = new URLSearchParams(
        decodeURIComponent(returnURL?.split("?")[1])
      ).get("utm_source");
      if (utm_source) {
        obj["utm_source"] = utm_source;
      }
    }
    dispatch({
      type: Action_Type.handleUTM,
      payload: obj,
    });
  }, [search]);

  useEffect(() => {
    let obj = {
      phoneNumber: phoneNumber,
    };

    dispatch({
      type: Action_Type.handleUTM,
      payload: obj,
    });
  }, [phoneNumber]);

  useEffect(() => {
    if (city && Object.keys(city).length > 0 && isPreFilledData) {
      let obj = {
        city: isPreFilledData,
      };

      dispatch({
        type: Action_Type.updateCity,
        payload: obj,
      });
    }
  }, [city, isPreFilledData]);

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let obj = {
      [name]: value,
    };
    if (name == "profession") {
      obj.speciality = "";
    }
    handleFormDetails(obj);
    scrollToBottom("signupForm");
  };
  const handleJoinModalClose = () => {
    toggleSignInbtn("showJoinModal", false);
  };
  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: true, errors: defaultErr },
      });

      let error = await validateForm();

      if (!isValidForm(error)) {
        dispatch({
          type: Action_Type.loading,
          payload: { isLoading: false },
        });
        return;
      }
      handleRegisterBtn();
    } catch (error) {
      let errors = state.errors;
      if (error.code) {
        errors.description = error.message;
      }
      dispatch({
        type: Action_Type.loading,
        payload: { isLoading: false, errors: errors },
      });
    }
  };

  const handleRegisterBtn = () => {
    let registeration_source = localStorage.getItem("registeration_source");
    let obj = {
      email: formDetails.email,
      phoneNumber: formDetails.phoneNumber,
      firstName: formDetails.firstName.trim(),
      lastName: formDetails.lastName.trim(),
      profession: formDetails.profession,
      geoHash: null,
      ...formDetails.city,
      termsAndConditions: false,
      marketing: false,
      date: new Date().getTime(),
      utm_source: state.utm_source,
      utm_medium: state.utm_medium,
      utm_campaign: state.utm_campaign,
      automation: true,

      sessionId: formDetails?.sessionId,

      userMetaData: {
        registrationSource:
          formDetails?.userMetaData?.registrationSource ||
          registeration_source ||
          "ott", //partiallyRegistered
      },
    };
    if (formDetails.employeeCode) {
      obj["employeeCode"] = formDetails.employeeCode;
    }
    if (formDetails.speciality) {
      obj["speciality"] = formDetails.speciality;
    }
    if (!obj["pincode"]) {
      delete obj["pincode"];
    }

    let extraData = { Status: false, message: "" };
    usersAPI
      .createUser(obj)
      .then(async (res) => {
        extraData["Status"] = true;
        if (!res.data.userId) {
          dispatch({
            type: Action_Type.loading,
            payload: {
              isLoading: false,
              errors: { defaultError: "Please Try Again Later" },
            },
          });
          return;
        }
        localStorage.removeItem("registeration_source");

        addGAWithNoUser("join_btn", { ...obj, userId: res.data.userId });

        dispatch({
          type: Action_Type.loading,
          payload: {
            isLoading: false,
            errors: { defaultError: "" },
          },
        });
        updateMultipleState({
          // showJoinModal: false,
          loading: false,
        });

        document.dispatchEvent(new CustomEvent("user-reg"))
        if (state.utm_source === "googleads") {
          // window.dataLayer.push({
          //   event: "pageview",
          //   page: {
          //     url: "location",
          //     title: "title",
          //   },
          // });
          addScript(
            "https://www.googletagmanager.com/gtag/js?id=UA-228483250-1",
            () => {
              console.log("loaded");
            }
          );
        }
        // let thanksURL = `/thankyou?`;
        // thanksURL = state.utm_source
        //   ? thanksURL.concat(`utm_source=${state.utm_source}&`)
        //   : "";
        // thanksURL = state.utm_medium
        //   ? thanksURL.concat(`utm_medium=${state.utm_medium}&`)
        //   : "";
        // thanksURL = state.utm_campaign
        //   ? thanksURL.concat(`utm_campaign=${state.utm_campaign}`)
        //   : "";
        // window.history.replaceState({}, null, thanksURL);
        await handleLoginBtn();
      })
      .catch((error) => {
        const { data: err } = error;
        extraData["Status"] = false;
        extraData["message"] = err.message;
        if (err.code === FirebaseErrorCodes.USER_EXISTS_CLOUD_FUCTION) {
          updateMultipleState({ alreadyRegistered: true });
          dispatch({
            type: Action_Type.loading,
            payload: {
              isLoading: false,
              errors: { defaultError: extraData["message"] },
            },
          });
          return;
        } else if (err?.code === FirebaseErrorCodes.AUTH_INVALID_NUMBER) {
          extraData["message"] = "Please Enter a valid Mobile Number";
          dispatch({
            type: Action_Type.loading,
            payload: {
              isLoading: false,
              errors: { defaultError: extraData["message"] },
            },
          });
        } else {
          dispatch({
            type: Action_Type.loading,
            payload: {
              isLoading: false,
              errors: { defaultError: extraData["message"] },
            },
          });
        }
      })
      .finally(() => {
        addCleverTapAnalytics(
          SIGN_UP_EVENT,
          getSignUpData({
            ...obj,
            "Method Used": "phone",
            Status: extraData["Status"],
            "Status Message": extraData["message"],
          })
        );
      });
  };

  const addScript = (url, callback) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }

    script.src = url;
    script.innerHTML = `
    window.dataLayer1 = window.dataLayer1 || [];
    function gtag() {
      dataLayer1.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "UA-228483250-1");
  `;
    document.getElementsByTagName("body")[0].appendChild(script);
  };

  const validateForm = async () => {
    let errors = { ...defaultErr };
    errors.defaultError = "";
    try {
      await schema.validate(formDetails, { abortEarly: false });
    } catch (error) {
      if (error.inner) {
        error.inner.forEach((err) => {
          const fieldName = err.path;
          const errorMessage = err.message;
          if (fieldName) {
            fieldName == "city.city"
              ? (errors.city = errorMessage)
              : (errors[fieldName] = errorMessage);
            return true;
          }
        });
      }
    }
    let cityData = document.getElementById("city").value;
    cityData.length < 1 && (errors.city = "Please Enter Your City");

    dispatch({
      type: Action_Type.handleError,
      payload: { errors: { ...errors } },
    });
    return errors;
  };

  const isValidForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
    return valid;
  };

  const isSameEmailError =
    state.errors.defaultError &&
    state.errors.defaultError.includes("same Email");
  const exists = openRoutes.some((hideRoute) =>
    window.location.pathname.includes(hideRoute)
  );

  if (alreadyRegistered) {
    return (
      <div className={`modalOverlayWithBlur ${styles_login["container"]}`}>
        <div className={`text-align-center ${styles_login["box"]}`}>
          <h1 className={styles_login["not-registered-heading"]}>
            Already Registered
          </h1>
          <div
            className={styles_login["signin-form"]}
            style={{ alignItems: "center" }}
          >
            <div className={styles_login["not-registered"]}>
              It seems that{" "}
              <span className={styles_login["not-registered-number"]}>
                {isSameEmailError ? formDetails.email : formDetails.phoneNumber}
              </span>
              <br />
              is already registered with us.
            </div>
            <div className={styles_login["not-registered-img"]}>
              {/* <img src={clipBoardBtnImg} alt="" /> */}
            </div>
            <div>
              {isSameEmailError
                ? "Please use other email."
                : "Would you like to SignIn ?"}
            </div>
            <div className={styles_login["formbtns"]}>
              <button
                onClick={() => {
                  updateMultipleState({
                    alreadyRegistered: false,
                    showSignInModal: isSameEmailError ? false : true,
                    showJoinModal: isSameEmailError ? true : false,
                  });
                }}
                className={`btn ${styles_login["submit-btn"]}`}
              >
                {isSameEmailError ? "Register Now" : "SignIn"}
              </button>
              {!exists && (
                <button
                  className={`btn ${styles_login["notnow-btn"]}`}
                  onClick={resetState}
                >
                  Not Now
                </button>
              )}
            </div>
          </div>
          {!exists && (
            <div onClick={resetState} className={styles_login["closeBtn"]}>
              <img src={closebtnImg} alt="close" />
            </div>
          )}
        </div>
      </div>
    );
  }

  const onCityError = (errCode) => {
    let error = "";
    switch (errCode) {
      case "ZERO_RESULTS":
        error = "No result found.";
        break;
      default:
        error = "Some internal error occurred.";
        break;
    }
    dispatch({
      type: Action_Type.handleError,
      payload: { errors: { city: error } },
    });
  };

  const handlePlaceSelect = async (address, placeId, suggestion) => {
    try {
      let resp = await geocodeByAddress(address);
      let addressObject = resp[0];

      let lat = addressObject.geometry?.location.lat();
      let lng = addressObject.geometry?.location.lng();
      if (!lat) {
        lat = 20.5937;
      }
      if (!lng) {
        lng = 78.9629;
      }

      let locationResult = {
        state: "",
        city: "",
        country: "",
        pincode: null,
        location: {
          lat,
          lng,
        },
      };

      addressObject.address_components.forEach((element) => {
        if (element.types.indexOf("locality") !== -1) {
          locationResult.city = element.long_name;
        } else if (
          element.types.indexOf("administrative_area_level_1") !== -1
        ) {
          locationResult.state = element.long_name;
        } else if (element.types.indexOf("country") !== -1) {
          locationResult.country = element.long_name;
        } else if (element.types.indexOf("postal_code") !== -1) {
          locationResult.pincode = element.long_name;
        }
      });

      if (!locationResult.city) {
        locationResult.city = locationResult.state;
      }
      dispatch({
        type: Action_Type.updateCity,
        payload: {
          city: address,
        },
      });
      handleFormDetails({ city: locationResult });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className={`modalOverlayWithBlur`} />

      {!state.isRegistered ? (
        <div className={`${styles["container"]}`}>
          <div className={styles["box"]}>
            <h1>REGISTER NOW</h1>
            <form id="signupForm" className={styles["signin-form"]}>
              <label
                htmlFor={inputs[0].name}
                style={{ marginBottom: "0.5rem" }}
              >
                {inputs[0].label}
              </label>
              <div
                style={{ display: "flex", gap: "1rem", marginBottom: "0.8rem" }}
              >
                <input
                  id={inputs[0].name}
                  name={inputs[0].name}
                  className={inputs[0].className}
                  type={inputs[0].type}
                  placeholder={inputs[0].placeholder}
                  value={formDetails[inputs[0].name]}
                  required={inputs[0].required}
                  disabled={inputs[0].disabled}
                  readOnly={inputs[0].readOnly}
                  onChange={(e) => handleInputChange(e)}
                />
                <input
                  id={inputs[1].name}
                  name={inputs[1].name}
                  className={inputs[1].className}
                  type={inputs[1].type}
                  placeholder={inputs[1].placeholder}
                  value={formDetails[inputs[1].name]}
                  required={inputs[1].required}
                  disabled={inputs[1].disabled}
                  readOnly={inputs[1].readOnly}
                  onChange={(e) => handleInputChange(e)}
                />
              </div>
              {inputs.map((input) => {
                if (
                  input.name === "speciality" &&
                  (!formDetails.profession ||
                    hideSpecialityForProfession.includes(
                      formDetails.profession
                    ))
                ) {
                  // if (!formDetails.profession || hideSpecialityForProfession.includes(formDetails.profession)) {
                  return;
                  // }
                }
                if (
                  input.name === "employeeCode" &&
                  !showEmployeeCodeForProfession.includes(
                    formDetails.profession
                  )
                ) {
                  return;
                }
                return (
                  <React.Fragment key={input.name}>
                    {input.name !== "firstName" &&
                      input.name !== "lastName" && (
                        <div
                          className={"input-group"}
                          style={{ marginBottom: "0.8rem" }}
                        >
                          <label
                            htmlFor={input.name}
                            className="d-block"
                            style={{ marginBottom: "0.5rem" }}
                          >
                            {input.label}
                          </label>
                          {input.name === "phoneNumber" ? (
                            <PhoneInput
                              defaultCountry={whiteListCountries[0]}
                              international
                              addInternationalOption={false}
                              countryCallingCodeEditable={false}
                              limitMaxLength
                              // countries={whiteListCountries}
                              withCountryCallingCode
                              className="form-control"
                              name="phoneNumber"
                              value={formDetails[input.name]}
                              id="phone"
                              placeholder="Enter Mobile Number"
                              onChange={handlePhoneNumber}
                              onKeyDown={handleCaretPosition}
                              onClick={handleCaretPosition}
                              onFocus={() => {
                                dispatch({
                                  type: Action_Type.handleError,
                                  payload: {
                                    isLoading: false,
                                    errors: { ...defaultErr },
                                  },
                                });
                              }}
                            />
                          ) : input.name === "city" ? (
                            <PlacesAutocomplete
                              onError={onCityError}
                              value={state[input.name]}
                              onChange={(value) => {
                                dispatch({
                                  type: Action_Type.updateCity,
                                  payload: { city: value },
                                });
                              }}
                              onSelect={handlePlaceSelect}
                              searchOptions={{
                                // sessionToken: sessionToken,
                                types: ["(cities)"],
                                fields: ["address_components"],
                                // componentRestrictions: {
                                //   country: whiteListCountries,
                                // },
                              }}
                              debounce={CITY_DEBOUNCE}
                              shouldFetchSuggestions={
                                state[input.name]?.length >= CITY_FETCH_MIN_CHAR
                              }
                            >
                              {({
                                getInputProps,
                                suggestions,
                                getSuggestionItemProps,
                                loading,
                              }) => (
                                <div style={{ position: "relative" }}>
                                  <input
                                    className="form-control"
                                    {...getInputProps({
                                      placeholder: input.placeholder,
                                      name: input.name,
                                      id: input.name,
                                      required: input.required,
                                      disabled: input.disabled,
                                      readOnly: input.readOnly,
                                    })}
                                  />
                                  <div
                                    style={{
                                      position: "absolute",
                                      zIndex: "10",
                                      border: `${suggestions.length === 0
                                        ? "0px"
                                        : "1px solid rgba(255, 255, 255, 0.4)"
                                        }`,
                                      width: "100%",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {loading && <div>Loading...</div>}

                                    {suggestions.map((suggestion, index) => {
                                      const style = {
                                        backgroundColor: suggestion.active
                                          ? "#eb4547"
                                          : "rgba(44, 64, 103, 1)",
                                        color: "#ffff",
                                        padding: "0.5rem",
                                        cursor: "pointer",
                                      };
                                      return (
                                        <div
                                          {...getSuggestionItemProps(
                                            suggestion,
                                            {
                                              style,
                                            }
                                          )}
                                          key={index}
                                        >
                                          <div
                                            style={{ width: "100%" }}
                                            key={suggestion.description}
                                            value={suggestion.description}
                                          >
                                            {/* {suggestion.description
                                              .split(",")
                                              .slice(0, -1)
                                              .join(",")} */}
                                            {suggestion.description}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          ) : input.type === "select" ? (
                            input.needSearch ? (
                              <CustomDropDown
                                className={`${input.className}`}
                                options={input.data}
                                input={input}
                                value={
                                  formDetails[input.name] ?? input.placeholder
                                }
                                onFocus={() => {
                                  setTimeout(() => {
                                    scrollToBottom("signupForm");
                                  }, 200);
                                }}
                                onSelect={(data) => {
                                  let obj = {
                                    [input.name]: data,
                                  };
                                  setTimeout(() => {
                                    scrollToBottom("signupForm");
                                  }, 200);
                                  handleFormDetails(obj);
                                }}
                              />
                            ) : (
                              <select
                                defaultValue={input.placeholder}
                                id={input.name}
                                name={input.name}
                                className={`${input.className} ${styles.dp}`}
                                type={input.type}
                                placeholder={input.placeholder}
                                required={input.required}
                                value={
                                  formDetails[input.name] ?? input.placeholder
                                }
                                onChange={(e) => {
                                  handleInputChange(e);
                                }}
                              >
                                <option value="none">
                                  {input.placeholder}
                                </option>

                                {input.data.map((val) => (
                                  <option value={val} key={val}>
                                    {val}
                                  </option>
                                ))}
                              </select>
                            )
                          ) : (
                            <input
                              id={input.name}
                              name={input.name}
                              className={input.className}
                              type={input.type}
                              placeholder={input.placeholder}
                              value={formDetails[input.name]}
                              required={input.required}
                              disabled={input.disabled}
                              readOnly={input.readOnly}
                              onChange={(e) => handleInputChange(e)}
                            />
                          )}
                        </div>
                      )}
                    {state.errors[input.name] && (
                      <div className="error">{state.errors[input.name]}</div>
                    )}
                  </React.Fragment>
                );
              })}
              {state.errors.defaultError && (
                <div className="error">{state.errors.defaultError}</div>
              )}
            </form>
            <button
              onClick={handleSubmit}
              disabled={state.isLoading}
              className={`btn ${styles["submit-btn"]}`}
            >
              {state.isLoading ? (
                <img src={LoaderImg} alt="" height="100%" />
              ) : (
                "JOIN"
              )}
            </button>
            {!exists && (
              <div
                onClick={handleJoinModalClose}
                className={styles["closeBtn"]}
              >
                <img src={closebtnImg} alt="close" />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={`${styles["container"]}`}>
          <div className={`${styles["box"]} ${styles["registeredContainer"]}`}>
            <div className={`${styles["text1"]}`}>
              Dear Dr. {formDetails.firstName},
              <br />
              Thank you, you have been
              <br />
              registered successfully
            </div>
            <div className={`${styles["textThankYou"]}`}>
              <img
                src={thankYouImg}
                alt="Thank You"
                height="100%"
                width="100%"
              />
            </div>
            {!exists && (
              <div
                onClick={handleJoinModalClose}
                className={styles["closeBtn"]}
              >
                <img src={closebtnImg} alt="close" />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default JoinModal;
